/***
 * flattenProjectScheduleMilestones returns completely flattened milestones list for all schedules on a project
 * @param project: project object
 */

import { flattenMilestones } from "@/helpers";
import { IMilestone, IProject } from "@/interfaces";

export const flattenProjectScheduleMilestones = (project: IProject) => {
  const results: IMilestone[] = [];
  if (project?.schedules) {
    project.schedules.forEach((schedule) => {
      if (schedule.milestones?.length > 0) {
        const scheduleMilestones = flattenMilestones(schedule.milestones);
        scheduleMilestones.forEach((milestone) => {
          results.push(milestone);
        });
      }
    });
  }
  return results;
};
